<script>
import { mapState, mapGetters } from 'vuex';

export default {
  props: ['value', 'disabled', 'placeholder', 'maxlength', 'minheight', 'client'],
  data() {
    return {
      $value: `${this.value}`,
    };
  },
  mounted() {
    this.updateTextareaHeightOnResize();
    if ((this.isOperator || this.customerUc) && this.isFrame) {
      // в режиме айфрейма не всегда успевает корректно отрабатывать
      // вычисление высоты текстареи без таймаута (пр - интеграция с CRM арм оператора,
      // чат UC)
      requestAnimationFrame(() => {
        this.adaptiveHeight();
      });
    } else {
      this.adaptiveHeight();
    }
  },
  methods: {
    update() {
      this.$emit('update:value', this.$data.$value);
      this.adaptiveHeight();
    },
    updateTextareaHeightOnResize() {
      window.addEventListener('resize', this.adaptiveHeight);
    },
    adaptiveHeight() {
      const textarea = this.$refs.input;
      if (textarea) {
        if (!this.minheight) {
          textarea.style.height = '';
          textarea.style.height = `${textarea.scrollHeight}px`;
        } else {
          textarea.style.height = `${this.minheight}px`;
        }
      }
    },
    clear() {
      this.$data.$value = '';
      this.$emit('update:value', this.$data.$value);
      this.$nextTick(() => {
        this.adaptiveHeight();
      });
    },
    handleWordWrapping() {
      const textarea = this.$refs.input;
      const tmpStr = textarea.value;
      const startPos = textarea.selectionStart;
      const endPos = textarea.selectionEnd;
      const firstPartString = tmpStr.substring(0, startPos);
      const secondPartString = tmpStr.substring(endPos, tmpStr.length);
      const carretPlace = endPos + 1;
      this.$data.$value = `${firstPartString}\r\n${secondPartString}`;
      this.update();
      this.$nextTick(() => {
        this.setCarretPosition(textarea, carretPlace);
      });
    },
    setCarretPosition(ctrl, pos) {
      ctrl.focus();
      ctrl.setSelectionRange(pos, pos);
    },
    focus() {
      this.$emit('focus');
    },
    blur() {
      this.$emit('blur');
    },
  },
  computed: {
    ...mapState('app', ['mode', 'isFrame']),
    ...mapState('home', ['ucceIntegration']),
    ...mapGetters('app', ['isUcEnv', 'isRbEnv']),
    customerRb() {
      return this.isRbEnv && this.client === 'customer';
    },
    customerUc() {
      return this.isUcEnv && this.client === 'customer';
    },
    miniMode() {
      return this.mode === 'MINI' && this.isOperator && this.isFrame && !this.ucceEnabled;
    },
    isOperator() {
      return this.client === 'operator';
    },
    ucceEnabled() {
      return this.ucceIntegration;
    },
  },
  watch: {
    isChatExpanded(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.adaptiveHeight();
        });
      }
    },
    value() {
      this.$data.$value = `${this.value ? this.value : ''}`;
      this.$refs.input.value = this.$data.$value;
      this.adaptiveHeight();
    },
    async miniMode() {
      requestAnimationFrame(() => {
        this.adaptiveHeight();
      });
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.adaptiveHeight);
  },
};
</script>

<template lang="pug">
span(:class="[$style.root, miniMode && $style.rootMini, customerRb && $style.rb, customerUc && $style.uc, (customerRb || customerUc) && 'custom-inputText', 'custom-inputText-root']")
  textarea(
    @focus="focus"
    @blur="blur"
    type="text",
    ref="input",
    @input="update()",
    @change="update()",
    :class="[$style.input, 'custom-inputText-input']",
    :placeholder="placeholder",
    :disabled="disabled",
    :maxlength="maxlength",
    :style="minheight && { height: minheight + 'px' }"
    v-model='$data.$value',
    spellcheck)
  span(:class="[$style.border, 'custom-inputText-border']")
</template>

<style module lang="sass">
.root
  display: block
  width: 100%
  padding-bottom: 12px
  position: relative
  &Mini
    padding-bottom: 8px
.input
  display: block
  padding: 0
  border: 0
  box-sizing: border-box
  outline: none
  color: $color_text
  font-size: FS_INPUT
  height: 16px
  max-height: 160px
  line-height: 16px
  font-weight: 500
  background-color: transparent
  caret-color: $color_main
  width: 100%
  resize: none
  overflow-x: hidden
  &:hover + .border
    background-color: $color_main
    height: 2px

  &:focus + .border
    background-color: $color_main
    height: 2px

  &:disabled
    cursor: not-allowed
    & + .border
      background-color: transparent
      height: 1px
      border-bottom: 1px dotted $color_text_second

.border
  display: block
  position: absolute
  left: 0
  right: 0
  bottom: 0
  height: 2px
  background-color: $color_divider
  transition: background-color $a_speed, height $a_speed

.rb
  .input
    font-size: 13px
    font-family: "Muller", sans-serif
    caret-color: $color_rb
    &:hover + .border
      background-color: $color_rb

    &:focus + .border
      background-color: $color_rb
  &.root
    padding-bottom: 8px
.uc
  .input
    font-size: 18px
    font-family: "Uc", sans-serif
    caret-color: $color_uc
    line-height: 22px
    min-height: 22px
    &:hover + .border
      background-color: $color_uc

    &:focus + .border
      background-color: $color_uc
  &.root
    padding-bottom: 8px

</style>
